import React from "react";
import PropTypes from "prop-types";
import { Button, Card, CardContent, Grid, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { get, set } from "@totalsoft/change-tracking-react";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import { emptyString } from "constants/defaultValues";
import MyProfileStyles from "features/user/styles";
import { ArrowBack } from "@material-ui/icons";

const useStyles = makeStyles(MyProfileStyles);

function ContactInfo({ selectedClientLens, onBack }) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography gutterBottom variant="h6">
          {t("Client.ContactPerson")}
        </Typography>
        <Grid container>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={4}>
              <CustomTextField
                fullWidth
                label={t("Client.FirstName")}
                value={(selectedClientLens.firstName |> get) || emptyString}
                onChange={selectedClientLens.firstName |> set |> onTextBoxChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <CustomTextField
                fullWidth
                label={t("Client.LastName")}
                value={(selectedClientLens.lastName |> get) || emptyString}
                onChange={selectedClientLens.lastName |> set |> onTextBoxChange}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={4}>
              <CustomTextField
                fullWidth
                label={t("Client.Email")}
                value={(selectedClientLens.email |> get) || emptyString}
                onChange={selectedClientLens.email |> set |> onTextBoxChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <CustomTextField
                fullWidth
                label={t("Client.Phone")}
                value={(selectedClientLens.phone |> get) || emptyString}
                onChange={selectedClientLens.phone |> set |> onTextBoxChange}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item container justifyContent="flex-end">
          <Button
            id="createClient_BackToSearchBtn"
            right="true"
            variant="contained"
            color="primary"
            onClick={onBack}
            endIcon={<ArrowBack />}
          >
            {t("General.BackToSearch")}
          </Button>
        </Grid>
      </CardContent>
    </Card>
  );
}

ContactInfo.propTypes = {
  selectedClientLens: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default ContactInfo;
